export default function(username_val) {
    const errMessage = `<ul>
            <li>Username must be 4 min length alphanumerical values and no spaces are allowed.</li>
            <li>The only special characters allowed are "-" and "_".</li>
        </ul>`;

    if (/^[0-9a-zA-Z_-]+$/.test(username_val) && username_val.length >= 4) {
        this.errorMessage = "";
        return true;
    } else {
        this.errorMessage = errMessage;
        return false;
    }
};
